__turbopack_context__.v({
  "grid": "CapacityConflictLaterTimesGrid-module-scss-module__4J_Eda__grid",
  "selected": "CapacityConflictLaterTimesGrid-module-scss-module__4J_Eda__selected",
});
